export default __webpack_public_path__ + "static/media/photo--lg--5.4d79f4ec.jpg";